import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: IndexPage,
  beforeLoad: async () => {
    throw redirect({
      to: "/signup",
    });
  },
});

function IndexPage() {
  return <></>;
}
